"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPhProductsQtyAndPrice = void 0;
const isPhysicalProduct_1 = require("./isPhysicalProduct");
const getPhProductsQtyAndPrice = (lineItems) => {
    const result = lineItems.reduce((acc, item) => {
        var _a;
        const { isPhProduct, isBasicPhProduct, isPhSubscriptionProduct } = (0, isPhysicalProduct_1.isPhysicalProduct)((_a = item.variant) === null || _a === void 0 ? void 0 : _a.attributes);
        if (!isPhProduct)
            return acc;
        return {
            physicalSubscriptionQty: isPhSubscriptionProduct
                ? acc.physicalSubscriptionQty + 1
                : acc.physicalSubscriptionQty,
            physicalProductsQty: isBasicPhProduct ? acc.physicalProductsQty + 1 : acc.physicalProductsQty,
            price: acc.price + item.totalPrice.centAmount / 100,
        };
    }, {
        physicalSubscriptionQty: 0,
        physicalProductsQty: 0,
        price: 0,
    });
    return {
        physicalProductsQty: result.physicalProductsQty,
        physicalSubscriptionQty: result.physicalSubscriptionQty,
        zuoraSubscriptionQty: result.physicalSubscriptionQty + (result.physicalProductsQty && 1),
        price: result.price,
    };
};
exports.getPhProductsQtyAndPrice = getPhProductsQtyAndPrice;
exports.default = exports.getPhProductsQtyAndPrice;
//# sourceMappingURL=getPhProductsQtyAndPrice.js.map